/* Cloud copy of tile schedules & progress. Tiles keep using localStorage;
   writes to SYNC_KEYS are mirrored to /api/user-state, and login restores them. */
import axios from 'axios';
import { BACKEND_URL } from './api';

export const SYNC_KEYS = [
  'fuel_fuse_v1', 'aegis_regimen_v1', 'destiny_codex_state_v1', 'bliss_power_user_calendar_v1',
  'bliss_force_schedule_v2', 'bliss_force_user_yoga_v1', 'bliss_force_timer_v1', 'bliss_tracker_v1',
  'bliss_agenda_v1', 'aura_codex_state_v1', 'aura_source_pings_v1', 'provenance_progress_v1',
];
const SYNC = new Set(SYNC_KEYS);
const TS_KEY = 'cloud_sync_ts_v1';
const timers = {};
let suppress = false;
let installed = false;
let enabled = false;

const readTs = () => { try { return JSON.parse(localStorage.getItem(TS_KEY) || '{}'); } catch { return {}; } };
const writeTs = (m) => { try { Storage.prototype.setItem.call(localStorage, TS_KEY, JSON.stringify(m)); } catch { /* ignore */ } };

const push = (key) => {
  clearTimeout(timers[key]);
  timers[key] = setTimeout(async () => {
    delete timers[key];
    if (!enabled) return;
    const value = localStorage.getItem(key);
    try {
      const { data } = await axios.put(`${BACKEND_URL}/api/user-state/${key}`, { value });
      const ts = readTs(); ts[key] = data.updated_at; writeTs(ts);
    } catch { /* retry on next write */ }
  }, 700);
};

export const installCloudSync = () => {
  if (installed || typeof Storage === 'undefined') return;
  installed = true;
  const set = Storage.prototype.setItem;
  const rem = Storage.prototype.removeItem;
  Storage.prototype.setItem = function setItem(k, v) {
    set.call(this, k, v);
    if (this === window.localStorage && SYNC.has(k) && !suppress) push(k);
  };
  Storage.prototype.removeItem = function removeItem(k) {
    rem.call(this, k);
    if (this === window.localStorage && SYNC.has(k) && !suppress) push(k);
  };
};

/* Server → device (newer wins); device-only keys are uploaded once. */
export const pullCloudState = async () => {
  enabled = true;
  try {
    const { data } = await axios.get(`${BACKEND_URL}/api/user-state`);
    const ts = readTs();
    suppress = true;
    SYNC_KEYS.forEach((k) => {
      const remote = data[k];
      if (remote && (!ts[k] || remote.updated_at > ts[k] || localStorage.getItem(k) == null)) {
        if (remote.value == null) localStorage.removeItem(k); else localStorage.setItem(k, remote.value);
        ts[k] = remote.updated_at;
      }
    });
    suppress = false;
    writeTs(ts);
    SYNC_KEYS.forEach((k) => { if (!data[k] && localStorage.getItem(k) != null) push(k); });
    window.dispatchEvent(new Event('bliss-cloud-restored'));
  } catch { suppress = false; }
};

/* Logout: stop syncing and wipe the device copy (the cloud copy stays). */
export const clearCloudLocal = () => {
  enabled = false;
  Object.keys(timers).forEach((k) => clearTimeout(timers[k]));
  suppress = true;
  try { SYNC_KEYS.forEach((k) => localStorage.removeItem(k)); localStorage.removeItem(TS_KEY); } catch { /* ignore */ }
  suppress = false;
};

/* Send any pending writes now (called before logout). */
export const flushCloud = async () => {
  const keys = Object.keys(timers);
  keys.forEach((k) => clearTimeout(timers[k]));
  await Promise.all(keys.map((k) => axios.put(`${BACKEND_URL}/api/user-state/${k}`, { value: localStorage.getItem(k) }).catch(() => {})));
  keys.forEach((k) => delete timers[k]);
};
